module.exports = __webpack_public_path__ + "static/media/waitlist-member-10.faff45ca.jpeg";